import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import moment from 'moment-timezone';
import CustomLoading from '../../../util_components/custom_loading';
import * as actions from '../../../../redux/action_creators';
import { short_time_day_format } from '../../../../constants';
import '../teachers_list/teachers_list.css';

// Read-only list of teachers with an active trial welcome video (PROD-6438). Uploads stay on the teacher profile.
class TrialWelcomeVideosList extends Component {
  componentDidMount() {
    const { get_trial_teacher_videos_list } = this.props;
    get_trial_teacher_videos_list();
  }

  render_row = (row) => {
    const { iana_timezone } = this.props;
    return (
      <tr key={row.teacher_uuid}>
        <td>{row.thumbnail_url ? <img src={row.thumbnail_url} alt={row.teacher_name} /> : null}</td>
        <td className="list-name-email">{row.teacher_name}</td>
        <td className="low-text">
          {moment
            .utc(row.created_date)
            .tz(iana_timezone || 'UTC')
            .format(short_time_day_format)}
        </td>
        <td>
          <a
            className="ct-small-btn link-btn"
            href={`/teacherprofile?id=${encodeURIComponent(row.teacher_uuid)}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Profile
          </a>
        </td>
      </tr>
    );
  };

  render() {
    const { trial_videos_list, trial_videos_list_status } = this.props;
    if (trial_videos_list_status === 'loading') {
      return <CustomLoading />;
    }
    return (
      <div className="common-page-container">
        <Helmet>
          <title>Trial Welcome Videos</title>
        </Helmet>
        <div className="common-page-title">
          <span style={{ color: 'var(--text-muted)' }}>
            Trial Welcome Videos{' '}
            <span style={{ color: 'var(--text-primary)', fontSize: '18px' }}>
              {trial_videos_list.length}
            </span>
          </span>
        </div>
        {trial_videos_list_status === 'fail' ? (
          <div style={{ color: 'var(--state-error-text)' }}>Could not load the list.</div>
        ) : null}
        <table style={{ width: '100%' }}>
          <tbody>
            <tr className="teachers-details-row">
              <td>THUMBNAIL</td>
              <td>TEACHER</td>
              <td>UPLOADED</td>
              <td>OPEN</td>
            </tr>
            {trial_videos_list_status === 'success' && trial_videos_list.length === 0 ? (
              <tr>
                <td className="low-text" colSpan={4}>
                  No teacher has a trial welcome video yet.
                </td>
              </tr>
            ) : null}
            {trial_videos_list.map(this.render_row)}
          </tbody>
        </table>
      </div>
    );
  }
}

TrialWelcomeVideosList.propTypes = {
  trial_videos_list: PropTypes.arrayOf(
    PropTypes.shape({
      teacher_uuid: PropTypes.string,
      teacher_name: PropTypes.string,
      thumbnail_url: PropTypes.string,
      created_date: PropTypes.string
    })
  ),
  trial_videos_list_status: PropTypes.string,
  iana_timezone: PropTypes.string,
  get_trial_teacher_videos_list: PropTypes.func.isRequired
};

TrialWelcomeVideosList.defaultProps = {
  trial_videos_list: [],
  trial_videos_list_status: 'none',
  iana_timezone: 'UTC'
};

const mapStateToProps = (state) => ({
  trial_videos_list: state.teachers.trial_videos_list,
  trial_videos_list_status: state.teachers.trial_videos_list_status,
  iana_timezone: state.home.iana_timezone
});

const mapDispatchToProps = (dispatch) => ({
  get_trial_teacher_videos_list: () => {
    dispatch(actions.get_trial_teacher_videos_list());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(TrialWelcomeVideosList);
